import React, { useState } from 'react'
 
 
import MRPRateCardList from './MRPRateCardList';
import MRPRateCardForm from './MRPRateCardForm';

const MRPRateCard= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <MRPRateCardForm addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <MRPRateCardList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default MRPRateCard